import React from 'react';
import manifest from '../manifest.json';

const BackToIndexLink = () => (
  <va-link href={`${manifest.rootUrl}/index`} text="Back to patterns index" />
);

export default BackToIndexLink;
